export default "__VITE_ASSET__skD0ekCt__"